import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/praying-hands.png'


const _withScopeId = n => (_pushScopeId("data-v-5763cd72"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "quote" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h1", { class: "m-15" }, "\"I will arise and go to my father\""),
      /*#__PURE__*/_createElementVNode("span", null, "Luke 15:18")
    ])
  ])
], -1))
const _hoisted_2 = { class: "angle-inset" }
const _hoisted_3 = { class: "page-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "c-g a-left" }, " Prodigal Prayer Watch has been set up to encourage us as believers to unite in prayer for the salvation of our loved ones, especially for children who have believing parents and who have in some way departed from the path of truth. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "bullet-small" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Do you have children, siblings, or other loved ones that are in need of God's work in their lives?"),
  /*#__PURE__*/_createElementVNode("li", null, "Do you believe in the power of prayer, especially united prayer with other believers?"),
  /*#__PURE__*/_createElementVNode("li", null, "Are you willing to join us in fervent, constant prayer for God to draw them to repentance?"),
  /*#__PURE__*/_createElementVNode("li", null, "If so, click the \"Sign Up\" button below to join us in praying and in sharing prayer requests.")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = { class: "box-container" }
const _hoisted_9 = { class: "box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Prayer Requests", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Click here to see the current list of the names of loved ones who need our prayer.", -1))
const _hoisted_12 = { class: "box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Prayer Schedule", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Click here to see the schedule of the prayer commitments already made.", -1))
const _hoisted_15 = { class: "box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Join Us In Prayer", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Click here to sign up so that you can add prayer requests or commit to pray.", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "notice" }, " NOTICE: If any of your friends have email but not web access, and if they would like to be part of this prayer chain, please let them know that they can sign up by contacting the administrators at the phone number or the email address below. ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'PrayerNeeds' })))
            }, "Prayer Needs")
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'Schedule' })))
            }, "Schedule")
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'SignIn' })))
            }, "Sign Up")
          ])
        ]),
        _hoisted_18,
        _hoisted_19,
        _hoisted_20
      ])
    ])
  ], 64))
}